import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#174195",
    },

    secondary: {
      main: "#215ED9",
    },
    neutral: {
      main: "#ffffff",
    },
    success: {
      main: "#B0FF0D",
    },
    failure: {
      main: "#FF5E40",
    },
  },
  typography: {
    fontFamily: ["Montserrat"].join(","),
  },
});

export default theme;
